import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { DateTime } from 'luxon';
import React from 'react';
import { Error } from '../../Error';
import { InputSizes, ValidationStates } from '../enums';
import { NumberInput } from '../NumberInput';
export function createYearInput(sizeType) {
  var _a;

  var InputComponent = NumberInput[sizeType];
  return _a = /*#__PURE__*/function (_React$Component) {
    _inherits(YearInputBase, _React$Component);

    var _super = _createSuper(YearInputBase);

    function YearInputBase(props) {
      var _this;

      _classCallCheck(this, YearInputBase);

      _this = _super.call(this, props);
      _this.displayName = "Input.Year.".concat(sizeType); //==== User Interaction Functions ===========================================

      _this.onBlur = function (dateValueFromInput) {
        _this.updateDateValidationState(dateValueFromInput);
      };

      _this.onChange = function (dateValueFromInput) {
        _this.props.onChange(dateValueFromInput);

        _this.setState({
          dateString: dateValueFromInput
        });

        if (dateValueFromInput.length >= 4) {
          _this.updateDateValidationState(dateValueFromInput);
        }
      }; //==== Formatting Functions ================================================


      _this.getFormattedDate = function (dateValueFromInput) {
        return DateTime.fromFormat(dateValueFromInput, 'yyyy');
      }; //==== Validation Functions=================================================


      _this.getValidationData = function (dateTime) {
        var isValidDate = dateTime.isValid;
        var errorMessage = 'The date specified is invalid. Enter a year YYYY.';
        var validationState = isValidDate ? ValidationStates.Success : ValidationStates.Error;
        return {
          validationState: validationState,
          errorMessage: errorMessage
        };
      };

      _this.updateDateValidationState = function (dateValueFromInput) {
        var dateIncompleteError = 'The date specified is invalid. Enter a year YYYY.';
        var isCompleteDate = dateValueFromInput.length === 4;
        var isDateEmpty = dateValueFromInput.length === 0;

        var validationData = _this.getValidationData(_this.getFormattedDate(dateValueFromInput));

        var errorMessage = !isCompleteDate && !isDateEmpty ? dateIncompleteError : validationData.errorMessage;
        var validationState = !isCompleteDate && !isDateEmpty && validationData.validationState === ValidationStates.Success ? ValidationStates.Error : validationData.validationState;

        _this.setState({
          validationState: validationState,
          errorMessage: validationState !== ValidationStates.Success ? errorMessage : null
        });

        _this.props.onYearValid(validationState === ValidationStates.Success, dateValueFromInput, isCompleteDate);
      };

      var validationData = _this.getValidationData(_this.getFormattedDate(props.value || ''));

      _this.state = {
        dateString: props.value,
        validationState: props.value && props.value.length > 0 ? validationData.validationState : null,
        errorMessage: props.errorMessage
      };
      return _this;
    }

    _createClass(YearInputBase, [{
      key: "render",
      value: function render() {
        // Make sure that we set the validation state correctly if there's
        // an error this component has detected in the input.
        var hasLocalValidationError = this.state.validationState === ValidationStates.Error || this.props.errorMessage;
        var validationState = hasLocalValidationError ? this.state.validationState : this.props.validationState;
        return React.createElement(React.Fragment, null, React.createElement(InputComponent, {
          id: this.props.id,
          dataTest: this.props.dataTest,
          disabled: this.props.disabled,
          required: this.props.required,
          value: this.state.dateString,
          validationState: validationState,
          onBlur: this.onBlur,
          onChange: this.onChange,
          placeholder: "YYYY",
          maxLength: 4
        }), this.state.errorMessage && React.createElement(Error, null, this.state.errorMessage));
      }
    }]);

    return YearInputBase;
  }(React.Component), _a.defaultProps = {
    onChange: function onChange() {},
    onYearValid: function onYearValid() {}
  }, _a;
}

function generateYearInputWithSizes() {
  var DefaultYearInput = createYearInput(InputSizes.Default);
  return Object.assign.apply(Object, [DefaultYearInput].concat(_toConsumableArray(Object.keys(InputSizes).map(function (sizeType) {
    return _defineProperty({}, sizeType, createYearInput(InputSizes[sizeType]));
  }))));
}

export var YearInput = generateYearInputWithSizes();